import { CustomTooltip } from "components";
import { CouponCreatedProps, CouponDetailsProps, CouponProps } from "../store/actionType";
import { CopyIcon } from "assets";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";
import { useState } from "react";

interface Props {
  couponData: CouponDetailsProps[];
}

const CreatedCouponCard: React.FC<Props> = ({ couponData }) => {
  const totalCoupon = couponData?.length || 0;
  const [copied, setCopied] = useState<{ [key: string]: boolean }>({});
  const [copiedAllCoupons, setCopiedAllCoupons] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);
  const handleCopy = async (id: string, code: string) => {
    const couponCode = couponData.map((items) => items.code);
    const success = await copyToClipboard(couponCode.toString() ?? "");
    if (success) {
      setCopied((prev) => ({ ...prev, [id]: true }));
      setShowTooltip(false);
      setTimeout(() => {
        setCopied((prev) => ({ ...prev, [id]: false }));
      }, 1500)
    }
  };
  const handleCopyAllCoupons = async (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();
    const couponCodes = couponData.map((item) => item.code).join("\n");
    const success = await copyToClipboard(couponCodes);
    if (success) {
      setCopiedAllCoupons(true);
      setShowTooltip(false);
      setTimeout(() => {
        setCopiedAllCoupons(false);
        setShowTooltip(true);
      }, 1500);
    }
  };

  return (
    <div className="container bg-gradient-to-r from-primary-400 to-primary-600 text-white p-6 rounded-lg shadow-lg max-w-md mx-auto">
      <div className="text-2xl font-bold mb-2">Special Offer!</div>
      <div className="text-lg mb-2">
        {totalCoupon === 0 ? (
          <>Generated coupons will be shown here.</>
        ) : (
          <>
            {" "}
            Total{" "}
            <span className="text-yellow-400 font-bold">
              {totalCoupon}
            </span>{" "}
            {totalCoupon > 1 ? "coupons" : "coupon"} generated successfully!
          </>
        )}
      </div>
      <div className="bg-white text-gray-800 rounded-lg p-4 max-h-60 overflow-y-auto space-y-2">
        {couponData?.length > 0 ? (
          couponData.map((coupon, index) => (
            <div
              key={coupon.id}
              className="relative flex justify-between items-center border rounded px-3 py-2 hover:shadow-sm"
            >
              <span className="font-semibold">{coupon.code ? "*******" :""}</span>

              <div className="flex items-center ml-auto space-x-2">
                <span className="text-sm text-gray-500">
                 Package : {coupon.package_name}
                </span>
                <CustomTooltip
                  title={copied[coupon.code] ? "Coupon copied!" : "Copy coupon"}
                  placement="right"
                >
                  <button onClick={()=>handleCopy(coupon.code.toString(), coupon.code)} className="p-1">
                    <CopyIcon className="size-4" />
                  </button>
                </CustomTooltip>
              </div>
            </div>
          ))
        ) : (
          <span className="text-gray-400">No coupons generated yet</span>
        )}
      </div>

      <div className="text-sm mt-4">
        <div className="relative flex items-center justify-between">
          <div>
            Valid until <span className="font-semibold">December 31, 2025</span>
          </div>
          {totalCoupon === 0 ? (
            <></>
          ) : (
            <div className="">
              <CustomTooltip
                title={showTooltip ? "Copy all coupons" : ""}
                placement="left"
              >
                <button
                  onClick={handleCopyAllCoupons}
                  className="p-1 flex text-yellow-400 font-bold"
                >
                  <CopyIcon className="size-4 mr-1" /> copy all
                </button>
              </CustomTooltip>
              {copiedAllCoupons && (
                <div className="absolute top-6 -right-2 bg-green-500 text-white px-3 py-1 rounded shadow-md text-sm animate-fadeInOut z-30">
                  <span className="text-yellow-400 font-bold">
                    {totalCoupon}
                  </span>{" "}
                  Coupons Copied!
                </div>
              )}
            </div>
          )}
        </div>
        <p>Terms and conditions apply.</p>
      </div>
    </div>
  );
};

export default CreatedCouponCard;
